export const quickFiltersConst = ['QUICK_FILTER_EMPTY', 'QUICK_FILTER_FILLED'];
